import { cn } from '../../lib/utils';
import { TrendingUp, TrendingDown } from 'lucide-react';

export function StatCard({ label, value, icon: Icon, trend, trendLabel, className }) {
  const isUp = trend > 0;
  return (
    <div className={cn('rounded-lg border bg-card p-5 shadow-[var(--shadow-1)] hover:shadow-[var(--shadow-2)] transition-shadow', className)} data-testid="stat-card">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-muted-foreground">{label}</p>
          <p className="text-2xl font-display font-bold tabular-nums mt-1">{value}</p>
          {(trend !== undefined && trend !== null) && (
            <div className={cn('flex items-center gap-1 mt-1.5 text-xs font-medium', isUp ? 'text-emerald-500' : 'text-red-500')}>
              {isUp ? <TrendingUp className="w-3.5 h-3.5" /> : <TrendingDown className="w-3.5 h-3.5" />}
              <span>{trendLabel || `${Math.abs(trend)}`}</span>
            </div>
          )}
        </div>
        {Icon && (
          <div className="p-2.5 rounded-lg bg-[var(--lumyn-content)]/10 text-[var(--lumyn-content)]">
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
    </div>
  );
}
